/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useRef } from "react";
import { Form } from "react-bootstrap";
import Scrollbars from "react-custom-scrollbars-2";
import { useSelector } from "react-redux";
import Images from "../../Api/Images";
import UploadFileAPI from "../../Api/uploadFIleApi";
import wsSend_request from "../../Api/ws/ws_request";
import { WebSocketContext } from "../../App";
import Upload from "../../assets/image/Upload.svg";
import cross_for_viewcard from "../../assets/image/cross_for_viewcard.svg";

 const Banners = () => {
     const { bannerList, accessToken } = useSelector(
    (state) => state.adminReducers
  );
  const { websocket } = useContext(WebSocketContext);

  const renderTrack = ({ style, ...props }) => {
    const trackStyle = {
      display: "none",
    };
    return <div style={{ ...style, ...trackStyle }} {...props} />;
  };

  function deleteBanner(id) {
    let param = {
      transmit: "single",
      url: "document_delete",
      request: {
        doc_id: id,
      },
    };
    wsSend_request(websocket, param);
    callDocumentList();
  }

  const UploadImage = async (e) => {
    const files = e.target.files[0];
    const formData = new FormData();
    formData.append("file", files, files.name);
    const fileresponse = await UploadFileAPI(accessToken, formData);
    if (fileresponse?.status === 200) {
      let param = {
        transmit: "single",
        url: "document_add",
        request: {
          document_image: fileresponse?.id,
          title: "",
          sub_title: "",
          doc_type:"banners",
          documents:[]
        },
      };
      wsSend_request(websocket, param);
      callDocumentList();
    }
  };

  useEffect(() => {
    callDocumentList();
  }, [websocket]);

  const callDocumentList = () => {
    let param = {
      transmit: "single",
      url: "document_list",
      request: {
        limit: "20",
        page_no: 1,
        doc_type:"banners"
      },
    };
    wsSend_request(websocket, param);
  };
  const fileInputRef = useRef(null);

  const handleClick = () => {
    fileInputRef.current.click();
  };
  return (
   <Scrollbars
        style={{ height: "calc(100vh - 185px)" }}
        renderView={(props) => <div {...props} className="view" />}
        renderTrackHorizontal={renderTrack}
        className="ScrollbarsSidebar"
      >
        <Form.Group>
          <div className="row mt-3 mb-2">
            <div className="col-12 col-md-12 col-sm-12 col-lg-12">
              <Form.Label className="ms-3 label_class_name_for_input mb-3">
                Upload Banner image
              </Form.Label>
            </div>
            <div
              className="file-upload ms-4 banner_upload_container"
              onClick={handleClick}
            >
              <img src={Upload} alt="Upload" />
              <h5
                className="text-banner-upload"
                style={{ position: "static", color: "#7C7C87" }}
              >
                Upload Banner picture
              </h5>
              <span
                className="text-banner-upload"
                style={{ position: "static", color: "#234DCA" }}
              >
                browse
              </span>
              <input
                type="file"
                onChange={UploadImage}
                ref={fileInputRef}
                accept=".png, .jpg,"
                style={{ display: "none" }}
              />
            </div>
          </div>
        </Form.Group>
        <div className="row " style={{ marginLeft: "0px" }}>
          <div className="col-12">
            <div className="d-flex gap-2 mt-4">
              {bannerList?.list?.length > 0 ? (
                bannerList.list.map((banner,index) => {
                  return (
                    <div key={index+1}>
                      <div className="banner_image_box">
                        <img
                          src={cross_for_viewcard}
                          alt="cross_for_viewcard"
                          className="cross_for_viewcard banner_image_box_image"
                          onClick={() => deleteBanner(banner.id)}
                        />
                        <Images
                          src={banner.document_image}
                          height={"100%"}
                          width={"100%"}
                          alt="Banner"
                        />
                      </div>
                    </div>
                  );
                })
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>
      </Scrollbars>
  )
}

export default Banners